export const environment = {
    // apiURL:'http://107.110.210.222/DMT_ProjectTrackingServices/api/',  //Astha
    // apiURL:'http://107.108.86.134/DMT_ProjectTrackingServices/api/', //Kaushal

    apiURL:'https://ajitkids.com/game/',
    //  apiURL:'http://107.110.239.23/DMT_ProjectTrackingServices/api/', //Astha SVPN
 };